import React from 'react';
import {useTranslation} from "react-i18next";
import {OcrMode, useOcrModeLabels,} from "../../../../models/ocr.models";
import {MetadataBox, MetadataLabel, MetadataRow, MetadataValue} from "./Metadata.styled";

interface MetadataProps {
    pagesLength: number;
    mode: OcrMode;
}

const Metadata = ({pagesLength, mode}: MetadataProps) => {
    const { t } = useTranslation();
    const ocrModeLabels = useOcrModeLabels();

    if (!pagesLength) return null;

    return (
        <MetadataBox role="list">
            <MetadataRow role="listitem">
                <MetadataLabel aria-hidden="true">{t('ocr.result.mode')}</MetadataLabel>
                <MetadataValue aria-label={`${t('ocr.result.mode')}: ${ocrModeLabels[mode].label || mode}`}>
                    {ocrModeLabels[mode].label || mode}
                </MetadataValue>
            </MetadataRow>

            <MetadataRow role="listitem">
                <MetadataLabel aria-hidden="true">{t('ocr.result.totalPages')}</MetadataLabel>
                <MetadataValue aria-label={`${t('ocr.result.totalPages')}: ${pagesLength}`}>
                    {pagesLength}
                </MetadataValue>
            </MetadataRow>
        </MetadataBox>
    );
};

export default Metadata;